import { render, staticRenderFns } from "./MomentInputTable.vue?vue&type=template&id=198c1d9c&scoped=true&"
import script from "./MomentInputTable.vue?vue&type=script&lang=js&"
export * from "./MomentInputTable.vue?vue&type=script&lang=js&"
import style0 from "./MomentInputTable.vue?vue&type=style&index=0&id=198c1d9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198c1d9c",
  null
  
)

export default component.exports